import _plugin_vue_export_helper_default from "../../../_virtual/_plugin-vue_export-helper.js";
import { createElementBlock, createElementVNode, openBlock, renderSlot } from "vue";
//#region src/components/tools/overlay.vue
var _sfc_main = { name: "DtcOverlay" };
var _hoisted_1 = { class: "d-w100p d-h100p" };
var _hoisted_2 = { class: "d-pe-none" };
var _hoisted_3 = { class: "d-h100p" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", _hoisted_1, [renderSlot(_ctx.$slots, "content"), createElementVNode("div", _hoisted_2, [createElementVNode("div", _hoisted_3, [renderSlot(_ctx.$slots, "overlay")])])]);
}
var overlay_default = /* @__PURE__ */ _plugin_vue_export_helper_default(_sfc_main, [["render", _sfc_render]]);
//#endregion
export { overlay_default as default };

//# sourceMappingURL=overlay.vue.js.map